module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAMAAADat72NAAAAUVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcqRVCAAAAGnRSTlMAECAwQE9QX2BvcH+AkJ+gr7C/wM/Q3+Dv8NUjxaIAAADdSURBVBgZfcGBeoIgAIXRizBjhlqiIv/7P+iYlanr2zl68N0AjN2XPggLL8tFJ2ZkbzDaMyNHo9HOnSKySpmi15ujaOQpokymsNr0FLVqil5KMMVGm0QxX2d+dUOsjfbYS06y390wXC9Gq8TbZOQGHpbOqLizSUaBt9lK8mycAntLJWniaVIFNCYCjYnAIMlmHoJ6oFYLOLUUVpLNrGolYLlRzDd+BRWOlRNnQYWHKYNX5iSo6FMtWVep58SqqPTkOIo6ajmwOunZ8fqjybx4fWB8H3OKbaTRf3yQ9ANGZyfTLuQt6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/f7.png
// module id = ygmc
// module chunks = 21